import { render, staticRenderFns } from "./bank-xy.vue?vue&type=template&id=23c550e4&scoped=true&"
import script from "./bank-xy.vue?vue&type=script&lang=js&"
export * from "./bank-xy.vue?vue&type=script&lang=js&"
import style0 from "./bank-xy.vue?vue&type=style&index=0&id=23c550e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c550e4",
  null
  
)

export default component.exports